export default {
    methods: {
        load_stat() {
            this.$http.get(`/apply/stat`).then((res) => {
                if (res.success) {
                    this.$store.commit("change_state", { name: "stat_approval", value: res.data });
                }
            });
        },
    },
};
